import { MapStation } from "../../core/models";

export class StopsState {
    searchText: string = '';
    searchedStops: MapStation[] = [];
  }
